"use client";

import React from "react";
import HomeLayout from "@/app/(home)/layout";
import { useMobile } from "@/hooks/use-responsive";
import styles from "@/app/(home)/layout.module.scss";
import Sidebar from "@/components/sidebar/sidebar";
import MobileHeader from "@/components/header/mobile-header/mobile-header";
import { useUndoCancel } from "@/hooks/use-undo-cancel";

// TODO: копіпаст home layout, тут тільки стиль інший
// мав конфлікт із nextjs подкапотним OmitWithTag<HomeLayoutProps, keyof LayoutProps, "default">
// пока на гітхабі висять opened issues за цим питанням, хз як юзать один базовий layout через параметри

const HomePageLayout = ({ children }: any) => {
  const { isMobile } = useMobile();
  const { Toaster } = useUndoCancel();

  return (
    <main className={styles.main}>
      {!isMobile && <Sidebar />}
      <div className={styles.home_content}>
        {isMobile && <MobileHeader />}
        {children}
        <Toaster />
      </div>
    </main>
  );
};

export default HomePageLayout;
